import {useNavigation} from '@react-navigation/native';
import React from 'react';
import {Text as NativeText} from 'react-native';

import {Button} from '../../components/Button';
import {Strings} from '../../constants/Strings';
import {Screens} from '../../constants/navigation';
import type {
  RootStackParamList,
  RootStackScreenProps,
} from '../../navigators/RootStackNavigator';
import {underlineText} from '../../styles';

type Navigation = RootStackScreenProps<keyof RootStackParamList>['navigation'];

export const TermsAndPrivacy = () => {
  const navigation = useNavigation<Navigation>();

  return (
    <>
      <Button
        variant="transparent"
        as={NativeText}
        style={underlineText}
        onPress={() => navigation.navigate(Screens.TermsConditions)}>
        {Strings.TERMS_OF_SERVICE}
      </Button>

      {' & '}

      <Button
        variant="transparent"
        as={NativeText}
        style={underlineText}
        onPress={() => navigation.navigate(Screens.PrivacyPolicy)}>
        {Strings.PRIVACY_POLICY}
      </Button>

      {'.'}
    </>
  );
};
